import React from 'react';
import Main from './main';

const EditProduct = (props) => {
  const [product, setProduct] = React.useState(props.product);
  const [productsImages, setProductsImages] = React.useState(props.products_images || []);
  const [productsDetails, setProductsDetails] = React.useState(props.products_details || []);
  const [company] = React.useState(props.product.company);

  return (
    <div className="container-for-circles-menu container col-lg-8 text-fz-14px text-fw-bold text-black-50">
      <div className="block block-rounded my-4 ml-0 mr-0">
        <div className="pt-0 block-content pl-2 pr-2 pb-0 pt-5">
          <Main
            props={props}
            product={product}
            setProduct={setProduct}
            productsImages={productsImages}
            setProductsImages={setProductsImages}
            productsDetails={productsDetails}
            setProductsDetails={setProductsDetails}
            company={company}
          />
        </div>
      </div>
    </div>
  );
};

export default EditProduct;
